export default __webpack_public_path__ + "static/media/cross.ff54fab7.svg";